import { getToken, getUserInfo } from "./auth.service";

export interface CommunityMessage {
  id: number;
  user_id: number;
  user_name?: string;
  content?: string;
  url?: string;
  message_type: "text" | "image" | "video" | "audio" | "file";
  created_at: string;
}

export const getCommunityMessages = (): Promise<CommunityMessage[]> => {
  return fetch(`${process.env.REACT_APP_API_URL}/community`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    method: "GET",
  }).then((x) => x.json());
};

export const postCommunityMessage = (
  text: string,
  file?: File
): Promise<CommunityMessage> => {
  const fd = new FormData();
  fd.append("user_id", String(getUserInfo().id));
  fd.append("user_name", String(getUserInfo().name || ""));
  if (text) fd.append("content", text);
  if (file) {
    const filename = (file as any).name || "upload";
    fd.append("file", file, filename);
    fd.append("files", file, filename);
  }
  return fetch(`${process.env.REACT_APP_API_URL}/community`, {
    headers: { Authorization: `Bearer ${getToken()}` },
    method: "POST",
    body: fd,
  }).then((x) => x.json());
};

export const deleteCommunityMessage = (id: number) => {
  return fetch(`${process.env.REACT_APP_API_URL}/community/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    method: "DELETE",
  }).then((x) => x.json());
};
